import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';
import { Icon, IconName } from '../../atoms/icons';
import { smallScreenHeight } from './constants';

export interface Props {
  badgeCount?: number;
}

export default class NavBadge extends React.Component<Props, any> {
  public render() {
    const { badgeCount } = this.props;

    return <StyledBadge className="badge">{badgeCount}</StyledBadge>;
  }
}

const StyledBadge = styled.div`
  position: absolute;
  color: white;
  background: ${colors.green500};
  border-radius: 1000px;
  font-size: 0.625rem;
  min-width: 1.25rem;
  text-align: center;
  right: 0.5rem;
  top: 0.5rem;
  padding: 0.125rem 0.25rem;
  font-family: Lato-Bold;

  @media screen and (max-height: ${smallScreenHeight}) {
    top: 0;
  }
`;
